import { HttpParams } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '@app/reducers';
import { CrudType,currentComponentPageBasedPermissionsSelector$,CustomDirectiveConfig,datePipeConversion,exportList,  getPDropdownData,  IApplicationResponse,  LoggedInUserModel,  ModulesBasedApiSuffix, onActionSubmittedUtil, PERMISSION_RESTRICTION_ERROR,  prepareDynamicTableTabsFromPermissions,  prepareGetRequestHttpParams, prepareRequiredHttpParams, ResponseMessageTypes, RxjsService, SERVER_REQUEST_DATE_TRANSFORM, sidebarDataSelector$, SnackbarService } from '@app/shared';
import { CrudService } from '@app/shared/services';
import { VarianceEscalationFilterModal } from '@modules/inventory/models';
import { InventoryModuleApiSuffixModels, INVENTORY_COMPONENT } from '@modules/inventory/shared';
import { TechnicalMgntModuleApiSuffixModels } from '@modules/technical-management/shared/enum.ts/technical.enum';
import { UserModuleApiSuffixModels } from '@modules/user';
import { Store } from '@ngrx/store';
import { DialogService } from 'primeng/api';
import { combineLatest, forkJoin } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { PrimeNgTableVariablesModel } from '../../../../../shared/models/prime-ng-table-list-component-variables.model';
import { handleNgrxStoreData, processStoreData } from '@app/shared/utils/combine-page-level.utils';
import { loggedInUserData } from '@modules/others';

@Component({
  selector: 'app-variance-esclation-list',
  templateUrl: './variance-esclation-list.component.html',
  styleUrls: ['./variance-esclation-list.component.scss'],
  styles: [`
      .filter-dropdwon-con {
        width: 100%;
        background-color: #fff;
        padding: 15px;
        border-radius: 7px;
        box-shadow: 0px 0px 0px 1px #cccccc61;
        top: 65px;
        right: 0px;
        z-index: 5;
      }
  `]
})
export class VarianceEsclationListComponent extends PrimeNgTableVariablesModel {
  row: any = {}
  isLoading: boolean;
  varianceEscalationFilterForm: FormGroup;
  showFilterForm = false;
  varianceNumberList: any = [];
  varianceUsersList: any = []
  warehouseList: any = [];
  divisionsList: any = [];
  branchesList: any = [];
  techAreasList: any = [];
  dateFormat = 'MMM dd, yyyy';
  filterData;
  varianceTypeList = [
    { value: 'E', label: "Excessive" },
    { value: 'S', label: "Shortpicked" },
  ];
  isStockCodeBlank: boolean = false;
  stockCodeErrorMessage: any = '';
  showStockCodeError: boolean = false;
  isStockError: boolean = false;
  filteredStockCodes = [];
  startTodayDate = 0;
  otherParams;
  pickingBatch;
  isANumberOnly = new CustomDirectiveConfig({ isANumberOnly: true, });
  constructor(private crudService: CrudService,
    private activatedRoute: ActivatedRoute,
    public dialogService: DialogService, private snackbarService: SnackbarService,
    private router: Router, private store: Store<AppState>, private formBuilder: FormBuilder,
    private rxjsService: RxjsService,
  ) {
    super();
    this.primengTableConfigProperties = {
      tableCaption: "Variance Escalation",
      selectedTabIndex: 0,
      breadCrumbItems: [{ displayName: 'Inventory Management', relativeRouterUrl: '' }, { displayName: 'Variance Escalation', relativeRouterUrl: '' }, { displayName: 'Variance Escalation List', relativeRouterUrl: '' }],
      tableComponentConfigs: {
        tabsList: [
          {
            caption: 'Variance Escalation',
            dataKey: 'varianceInvReqId',
            enableBreadCrumb: true,
            enableScrollable: true,
            enableFieldsSearch: true,
            rowExpantableIndex: 0,
            enableHyperLink: true,
            cursorLinkIndex: 0,
            enableAction: true,
            enableAddActionBtn: true,
            shouldShowFilterActionBtn: true,
            enableExportBtn: true,
            enablePrintBtn: true,
            printTitle: 'Stock Management',
            printSection: 'print-section0',
            columns: [{ field: 'varianceInvReqNumber', header: 'Variance Escalation Number', width: '200px' },
            { field: 'varianceInvestigationStatusName', header: 'Status', width: '200px', },
            { field: 'varianceInvReqUser', header: 'Created By', width: '200px' },
            { field: 'varianceInvReqDate', header: 'Creation Date & Time', width: '200px',isDateTime:true},
            { field: 'varianceType', header: 'Variance Type', width: '200px' },
            { field: 'orderTypeName', header: 'Stock Order Type', width: '200px' },
            { field: 'orderNumber', header: 'Stock Order Number', width: '200px' },
            { field: 'pickingBatchBarcode', header: 'Picking Batch Barcode', width: '200px' },
            { field: 'location', header: 'Location Serial Linked To', width: '200px' },
            { field: 'stockOrderNumberAssociatedWithSerial', header: 'Stock Order Number Associate With Serial', width: '200px' },
            { field: 'stockCode', header: 'Stock Code', width: '200px' },
            { field: 'stockName', header: 'Stock Description', width: '200px' },
            { field: 'serialNumber', header: 'Serial Number', width: '200px' },
            { field: 'quantity', header: 'Variance Qty', width: '200px', validateInput: this.isANumberOnly },
            ],
            apiSuffixModel: InventoryModuleApiSuffixModels.VARIANCE_ESCLATION_LIST,
            moduleName: ModulesBasedApiSuffix.INVENTORY
          }
        ]
      }
    }
    this.pickingBatch = this.activatedRoute.snapshot.queryParams.pickingBatch;
  }

  ngOnInit(): void {

    this.combineLatestNgrxStoreData();
    this.getRequiredListData();
    this.createVarianceFilterForm();
  }
  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(loggedInUserData), this.store.select(currentComponentPageBasedPermissionsSelector$)]
    ).subscribe((response) => {
      this.loggedInUserData= new LoggedInUserModel(response[0]);
      let permission = response[1][INVENTORY_COMPONENT.VARIANCE_ESCALATION]
      if (permission) {
        let prepareDynamicTableTabsFromPermissionsObj = prepareDynamicTableTabsFromPermissions(this.primengTableConfigProperties, permission);
        this.primengTableConfigProperties = prepareDynamicTableTabsFromPermissionsObj['primengTableConfigProperties'];
      }
    });
  }
  onChangeSelecedRows(e) {
    this.selectedRows = e;
  }

  getRequiredListData(pageIndex?: string, pageSize?: string, otherParams?: object) {
    this.loading = true;
    let InventoryModuleApiSuffixModels: InventoryModuleApiSuffixModels;
    otherParams={...otherParams,...{
      TechAreaManager: this.loggedInUserData.roleName == 'Technical Area Manager' ? true : false,
      UserId: this.loggedInUserData.userId
    }};
    if(this.pickingBatch)
      otherParams = {...otherParams,...{PickingBatchBarcode:this.pickingBatch}};

    this.otherParams = otherParams;
    InventoryModuleApiSuffixModels = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].apiSuffixModel;
    this.crudService.get(
      ModulesBasedApiSuffix.INVENTORY,
      InventoryModuleApiSuffixModels,
      undefined,
      false, prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)
    ).subscribe(data => {
      this.loading = false;
      this.rxjsService.setGlobalLoaderProperty(false);
      if (data.isSuccess) {
        this.dataList = data.resources;
        this.totalRecords = data.totalCount;
      } else {
        data.resources= null;
        this.dataList = data.resources
        this.totalRecords = 0;
      }
    })
  }
  exportList(pageIndex?: any, pageSize?: any) {
    exportList(this.otherParams,0,pageSize,ModulesBasedApiSuffix.INVENTORY,
      InventoryModuleApiSuffixModels.VARIANCE_ESCALATION_EXPORT,this.crudService,this.rxjsService,'Variance Esclation');
  }
  onActionSubmited(e) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }

  onCRUDRequested(type: CrudType | string, row?: object, unknownVar?: any): void {
    switch (type) {
      case CrudType.CREATE:
        this.openAddEditPage(CrudType.CREATE, row);
        break;
      case CrudType.GET:
        this.row = row ? row : { pageIndex: 0, pageSize: 10 };
        if(unknownVar){
          unknownVar.TechAreaManager = this.loggedInUserData.roleName == 'Technical Area Manager' ? true : false;
          unknownVar.UserId = this.loggedInUserData.userId;
        }

        unknownVar = {...unknownVar,...this.filterData}
        this.getRequiredListData(this.row["pageIndex"], this.row["pageSize"], unknownVar)
        break;
      case CrudType.VIEW:
        this.openAddEditPage(CrudType.VIEW, row);
        break;
      case CrudType.FILTER:
        this.displayAndLoadFilterData();
        break;
      case CrudType.EXPORT:
        if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canExport) {
          return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
         }
          let pageIndex =  this.row && this.row ["pageIndex"] ?  this.row ["pageIndex"]:0;
          let pageSize  =  this.row && this.row["pageSize"] ? this.row["pageSize"] : 10;
          this.exportList(pageIndex,pageSize);
        break;
      default:
    }
  }

  openAddEditPage(type: CrudType | string, editableObject?: object | string): void {
    switch (type) {
      case CrudType.VIEW:
      this.router.navigate(['/inventory/variance/variance-esclation/view'], {
        queryParams: {
          id: editableObject['varianceInvReqId']
        }, skipLocationChange: true
      });
      break;
      case CrudType.CREATE:
        this.router.navigate(['/inventory/variance/variance-esclation/add-edit'], {
          queryParams: {

          }, skipLocationChange: false
        });
        break;
    }
  }

  displayAndLoadFilterData() {

    this.showFilterForm = !this.showFilterForm;
    forkJoin([
      this.crudService.dropdown(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.UX_VARIANCE_NUMBER),
      this.crudService.dropdown(ModulesBasedApiSuffix.IT_MANAGEMENT, UserModuleApiSuffixModels.UX_USERS),
      this.crudService.dropdown(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.UX_WAREHOUSE,prepareRequiredHttpParams({ userId: this.loggedInUserData?.userId })),
      this.crudService.dropdown(ModulesBasedApiSuffix.IT_MANAGEMENT, TechnicalMgntModuleApiSuffixModels.UX_DIVISIONS),
    ]).subscribe((response: IApplicationResponse[]) => {
      response.forEach((resp: IApplicationResponse, ix: number) => {
        if (resp.isSuccess && resp.statusCode === 200) {
          switch (ix) {
            case 0:
              this.varianceNumberList = getPDropdownData(resp.resources);
              break;
            case 1:
              this.varianceUsersList = getPDropdownData(resp.resources);
              break;
            case 2:
              this.warehouseList = getPDropdownData(resp.resources);
              break;
            case 3:
              this.divisionsList = getPDropdownData(resp.resources);
              if (this.varianceEscalationFilterForm?.get('divisions').value?.length) {
                this.getSelectedBranchOptions(this.varianceEscalationFilterForm?.get('divisions').value);
              }
              break;
          }
        }
      });
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }

  createVarianceFilterForm(requisitionListModel?: VarianceEscalationFilterModal) {
    let purchaseListFilterModel = new VarianceEscalationFilterModal(requisitionListModel);
    this.varianceEscalationFilterForm = this.formBuilder.group({});
    Object.keys(purchaseListFilterModel).forEach((key) => {
      if (typeof purchaseListFilterModel[key] === 'string') {
        this.varianceEscalationFilterForm.addControl(key, new FormControl(purchaseListFilterModel[key]));
      }
    });

    // Date validation: createdToDate must be >= createdFromDate
    this.varianceEscalationFilterForm.get('createdFromDate').valueChanges.subscribe((createdFromDate: Date) => {
      if (createdFromDate) {
        const toDateControl = this.varianceEscalationFilterForm.get('createdToDate');
        if (toDateControl.value && toDateControl.value < createdFromDate) {
          toDateControl.setValue(null);
        }
      }
    });

    this.onFilterValueChanges();
  }

  onFilterValueChanges() {
    this.varianceEscalationFilterForm.get('divisions').valueChanges.subscribe((res) => {
      if (res) {
        this.getSelectedBranchOptions(res);
      }
    })
  }

  getSelectedBranchOptions(stockCode): void {
    this.branchesList = [];
    if (stockCode != '') {
      let params = new HttpParams().set('DivisionIds', this.varianceEscalationFilterForm.get('divisions').value);
      this.crudService.get(ModulesBasedApiSuffix.TECHNICIAN, TechnicalMgntModuleApiSuffixModels.UX_BRANCHES, undefined, true, params).subscribe((response: IApplicationResponse) => {
        if (response.resources && response.statusCode === 200) {
          this.branchesList = getPDropdownData(response.resources, 'branchName', 'branchId');
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
    }
  }

  inputChangeStockCodeFilter() {
    this.varianceEscalationFilterForm.get('stockCodes').valueChanges.pipe(debounceTime(100), distinctUntilChanged(),
      switchMap(searchText => {
        if (this.isStockError == false) {
          this.stockCodeErrorMessage = '';
          this.showStockCodeError = false;
        }
        else {
          this.isStockError = false;
        }

        if (searchText != null) {
          if (this.isStockCodeBlank == false) {
          }
          else {
            this.isStockCodeBlank = false;
          }
          if (!searchText) {
            if (searchText === '') {
              this.stockCodeErrorMessage = '';
              this.showStockCodeError = false;
              this.isStockError = false;
            }
            else {
              this.stockCodeErrorMessage = 'Stock code is not available in the system';
              this.showStockCodeError = true;
              this.isStockError = true;
            }
            return this.filteredStockCodes = [];
          }
          else {
            return this.crudService.get(
              ModulesBasedApiSuffix.INVENTORY,
              InventoryModuleApiSuffixModels.UX_ITEM_SEARCH_BY_CODE, null, true,
              prepareGetRequestHttpParams(null, null, { searchText, isAll: false }))
          }
        }
        else {
          return this.filteredStockCodes = [];
        }
      })).subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.resources.length > 0) {
          this.filteredStockCodes = response.resources;
          this.stockCodeErrorMessage = '';
          this.showStockCodeError = false;
          this.isStockError = false;
        } else {
          this.filteredStockCodes = [];
          this.stockCodeErrorMessage = 'Stock code is not available in the system';
          this.showStockCodeError = true;
          this.isStockError = true;
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
  }

  submitFilter() {
    let data = Object.assign({},
      this.varianceEscalationFilterForm.get('varianceInvReqIds').value == '' ? null : { VarianceInvReqIds: this.varianceEscalationFilterForm.get('varianceInvReqIds').value.join() },
      this.varianceEscalationFilterForm.get('varianceInvReqUserIds').value == '' ? null : { VarianceInvReqUserIds: this.varianceEscalationFilterForm.get('varianceInvReqUserIds').value },
      this.varianceEscalationFilterForm.get('warehouseId').value == '' ? null : { WarehouseId: this.varianceEscalationFilterForm.get('warehouseId').value },
      this.varianceEscalationFilterForm.get('stockCodes').value == '' ? null : { StockCodes: this.varianceEscalationFilterForm.get('stockCodes').value },
      this.varianceEscalationFilterForm.get('createdFromDate').value == '' ? null : { CreatedFromDate: datePipeConversion(this.varianceEscalationFilterForm.get('createdFromDate').value, SERVER_REQUEST_DATE_TRANSFORM) },
      this.varianceEscalationFilterForm.get('createdToDate').value == '' ? null : { CreatedToDate: datePipeConversion(this.varianceEscalationFilterForm.get('createdToDate').value, SERVER_REQUEST_DATE_TRANSFORM) },
      this.varianceEscalationFilterForm.get('varianceTypes').value == '' ? null : { VarianceTypes: this.varianceEscalationFilterForm.get('varianceTypes').value },
      this.varianceEscalationFilterForm.get('divisions').value == '' ? null : { Divisions: this.varianceEscalationFilterForm.get('divisions').value },
      this.varianceEscalationFilterForm.get('branches').value == '' ? null : { Branches: this.varianceEscalationFilterForm.get('branches').value },
      this.varianceEscalationFilterForm.get('techAreas').value == '' ? null : { TechAreas: this.varianceEscalationFilterForm.get('techAreas').value }, { UserId: this.loggedInUserData.userId}
    );
    this.filterData =data;
     this.onCRUDRequested('get');
    this.showFilterForm = !this.showFilterForm;
  }

  resetForm() {
    this.varianceEscalationFilterForm.reset();
    this.filterData =null;
     this.getRequiredListData('', '', null);
    this.showFilterForm = !this.showFilterForm;
  }

}
